/* eslint-disable no-useless-catch */

import api from '@/utils/api';
import { endpoints } from '@/utils/api';


export const listDistributorCompanies = async (params = {}) => {
  try {
    const response = await api.get(`${endpoints.salesTeamMapping}/distributors`, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch distributor companies');
  }
};

/** Current user's mapped distributors from sales_team_mapping (JWT user only). */
export const listMyMappedDistributors = async () => {
  try {
    const response = await api.get(`${endpoints.salesTeamMapping}/my-distributors`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch your mapped distributors');
  }
};

export const listSalesTeamMappings = async (params = {}) => {
  try {
    const response = await api.get(endpoints.salesTeamMapping, {
      params: {
        page: params.page || 1,
        pageSize: params.pageSize || 20,
        ...(params.search && { search: params.search }),
        ...(params.user_id !== undefined && { user_id: params.user_id }),
        ...(params.is_mapped !== undefined && { is_mapped: params.is_mapped }),
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalesTeamMapping = async (id) => {
  try {
    const response = await api.get(`${endpoints.salesTeamMapping}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const createSalesTeamMapping = async (mappingData) => {
  try {
    const response = await api.post(endpoints.salesTeamMapping, mappingData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSalesTeamMapping = async (id, mappingData) => {
  try {
    const response = await api.put(`${endpoints.salesTeamMapping}/${id}`, mappingData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSalesTeamMappingStatus = async (id, isActive) => {
  try {
    const response = await api.patch(`${endpoints.salesTeamMapping}/${id}/status`, {
      is_active: isActive
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateMappingStatus = async (id, isMapped) => {
  try {
    const response = await api.patch(`${endpoints.salesTeamMapping}/${id}/mapping-status`, {
      is_mapped: isMapped
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSalesTeamMapping = async (id) => {
  try {
    const response = await api.delete(`${endpoints.salesTeamMapping}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const assignSalesman = async (assignmentData) => {
  return createSalesTeamMapping({
    ...assignmentData,
    is_mapped: true
  });
};

export const unassignSalesman = async (mappingId) => {
  return updateMappingStatus(mappingId, false);
};

export const getUnmappedDistributors = async (params = {}) => {
  try {
    const response = await listSalesTeamMappings({
      ...params,
      is_mapped: false
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMappedDistributors = async (params = {}) => {
  try {
    const response = await listSalesTeamMappings({
      ...params,
      is_mapped: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const bulkAssignSalesmen = async (assignments) => {
  try {
    const promises = assignments.map(assignment => assignSalesman(assignment));
    const results = await Promise.all(promises);
    return results;
  } catch (error) {
    throw error;
  }
};

export const getMappingsByDistributor = async (distributorId) => {
  try {
    const response = await listSalesTeamMappings({
      distributor_id: distributorId
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMappingsByUser = async (userId) => {
  try {
    const response = await listSalesTeamMappings({
      user_id: userId
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const downloadCurrentMappingsExcel = async () => {
  try {
    const response = await api.get(`${endpoints.salesTeamMapping}/download-current`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const downloadCurrentStaffMappingsExcel = async () => {
  try {
    const response = await api.get(`${endpoints.salesTeamMapping}/download-current-staff`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadSalesMappingExcel = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`${endpoints.salesTeamMapping}/upload-excel`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadStaffMappingExcel = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`${endpoints.salesTeamMapping}/upload-excel-staff`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
